<template>
  <div class="md-sheet">
    <div v-if="sheetTitle" class="sheet-title">{{ sheetTitle }}</div>
    <div class="sheet-content">
      <template v-for="(node, idx) in flatNodes">
        <div :key="idx" class="sheet-item" :class="'level-' + node.level" :style="{ paddingLeft: node.level * 24 + 'px' }">
          <span class="sheet-bullet" :class="{ 'is-child': node.level > 0 }">
            {{ node.level > 0 ? '└─' : '' }}
          </span>
          <span class="sheet-index">{{ node.index }}</span>
          <span class="sheet-label">{{ node.text }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdSheet',
  props: {
    title: { type: String, default: '' },
    items: { type: String, default: '' },
    data: { type: String, default: '' },
    _rawJson: { type: String, default: '' },
    _componentKey: { type: String, default: '' }
  },
  computed: {
    sheetTitle() {
      const raw = this._parseJson(this._rawJson) || {}
      return this.title || raw.title || ''
    },
    sheetData() {
      const raw = this._parseJson(this._rawJson) || {}
      const items = this._parseJson(this.items) ||
        this._parseJson(this.data) ||
        this._parseJson(raw.items) ||
        this._parseJson(raw.data) ||
        []
      return Array.isArray(items) ? items : []
    },
    flatNodes() {
      const result = []
      this._flatten(this.sheetData, 0, '', result)
      return result
    }
  },
  methods: {
    _flatten(items, level, parentIndex, result) {
      items.forEach((item, i) => {
        const text = item.content || item.label || item.name || (typeof item === 'string' ? item : '')
        const index = parentIndex ? `${parentIndex}.${i + 1}` : `${i + 1}`
        result.push({ text, level, index })
        if (item.children && Array.isArray(item.children)) {
          this._flatten(item.children, level + 1, index, result)
        }
      })
    },
    _parseJson(value) {
      if (!value) return null
      if (typeof value === 'object') return value
      if (typeof value !== 'string') return null
      const cleaned = value.replace(/\n/g, '')
      try { return JSON.parse(cleaned) } catch {
        try { return JSON.parse(cleaned.replace(/'/g, '"').replace(/,\s*([}\]])/g, '$1')) } catch { return null }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-sheet {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
  margin: 8px 0;
  background: #fff;
  width: 100%;
}

.sheet-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.sheet-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sheet-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #1f2329;
  line-height: 2;

  &.level-0 {
    font-weight: 500;
  }
}

.sheet-bullet {
  color: #bbb;
  flex-shrink: 0;
  font-size: 12px;
  width: 20px;

  &.is-child {
    color: #c0c4cc;
  }
}

.sheet-index {
  color: #3370ff;
  font-weight: 600;
  flex-shrink: 0;
  min-width: 24px;
}

.sheet-label {
  color: #1f2329;
}
</style>
